export default __webpack_public_path__ + "static/media/chat.83959c5e.svg";